<template>
  <v-content>
    <v-container fluid fill-height class="grey lighten-5 pa-0">
      <v-layout row>
        <v-flex xs12 sm4 class="d-none d-sm-flex">
          <v-layout column>
            <v-img
              src="../assets/operations.jpg"
              gradient="324deg, rgba(2,0,36,1) 0%, rgba(3,65,245,1) 0%, rgba(40,81,190,0.9668242296918768) 0%, rgba(30,30,222,1) 2%, rgba(27,13,233,0.7875525210084033) 70%"
            >
              <div class="horizontal-center">
                <div class="text-center vertical-center ml-3 mr-3 mt-n10">
                  <div class="pa-12">
                    <v-img
                      src="../assets/telespazio-logo.png"
                      max-height="200"
                      max-width="300"
                      aspect-ratio="5.9"
                      class="mx-auto"
                    ></v-img>
                  </div>
                  <div
                    class="display-1 text-xs-center font-weight-black mb-3 white--text"
                  >
                    {{ $vuetify.lang.t("$vuetify.BEM_VINDO") }}
                  </div>
                  <span class="subheading white--text">{{
                    $vuetify.lang.t("$vuetify.MENSAGEM_INICIAL")
                  }}</span>
                </div>
              </div>
            </v-img>
          </v-layout>
        </v-flex>

        <v-flex class="active horizontal-center" fill-height>
          <v-layout column align-center full-width class="vertical-center">
            <v-flex xs12 mb-3>
              <div class="login-wrapper text-xs-center">
                <div
                  class="display-2 font-weight-black blue--text text--darken-2"
                >
                  {{ $vuetify.lang.t("$vuetify.OPERACOES") }}
                </div>
              </div>
            </v-flex>

            <v-flex xs24 mb-4>
              <span class="grey--text text--lighten-1">{{
                $vuetify.lang.t("$vuetify.MENSAGEM_LOGIN")
              }}</span>
            </v-flex>
            <v-flex>
              <v-text-field
                v-model.trim="username"
                label="Regular"
                full-width
                :placeholder="$vuetify.lang.t('$vuetify.USUARIO')"
                single-line
                solo
                autofocus
                prepend-inner-icon="mdi-account-outline"
              ></v-text-field>

              <v-text-field
                v-model.trim="password"
                label="Regular"
                full-width
                :placeholder="$vuetify.lang.t('$vuetify.SENHA')"
                single-line
                solo
                ref="password"
                :rules="
                  success
                    ? [rules.min, rules.emailMatch, rules.noProfile]
                    : [rules.min, rules.emailMatch]
                "
                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                prepend-inner-icon="mdi-lock"
                :type="show ? 'text' : 'password'"
                @click:append="show = !show"
                @keydown.enter="login()"
              ></v-text-field>
            </v-flex>
            <v-btn
              large
              dark
              ripple
              full-width
              color="blue darken-2"
              id="sign-up"
              :loading="loading"
              @click="login()"
              >{{ $vuetify.lang.t("$vuetify.ENTRAR") }}</v-btn
            >
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>

    <VerifyCodeDialog
      :dialog="showVerifyCodeDialog"
      :close="closeVerifyCodeDialog"
    />
  </v-content>
</template>

<script>
import VerifyCodeDialog from "../components/dialogs/VerifyCodeDialog.vue";
export default {
  components: { VerifyCodeDialog },
  created: function () {
    if (this.$vuetify.lang.current == "pt") {
      this.brazilUnselected = false;
      this.usaUnselected = true;
    } else {
      this.brazilUnselected = true;
      this.usaUnselected = false;
    }
  },
  data() {
    return {
      showVerifyCodeDialog: false,
      openVersionDialog: false,
      brazilUnselected: false,
      usaUnselected: true,
      username: "",
      image: "../assets/satelites.jpg",
      loading: false,
      show: false,
      password: "",
      success: undefined,
      rules: {
        min: (v) =>
          v.length >= 6 || this.$vuetify.lang.t("$vuetify.MINIMO_CARACTERES"),
        emailMatch: () =>
          this.success ||
          this.success == undefined ||
          this.$vuetify.lang.t("$vuetify.SENHA_INCORRETA"),
        noProfile: () =>
          (this.$getUser() &&
            this.$getUser().perfis &&
            this.$getUser().perfis.length > 0) ||
          this.$vuetify.lang.t("$vuetify.SEM_PERMISSAO"),
      },
    };
  },
  methods: {
    closeVerifyCodeDialog() {
      this.showVerifyCodeDialog = false;
    },
    login() {
      this.loading = true;
      this.$login(this.username, this.password).then((response) => {
        this.success = response;
        if (!response) {
          this.$refs["password"].validate(false);
          this.loading = false;
          return;
        }

        this.$getUser().then((user) => {
          if (user.email && user.email.length > 0) {
            this.showVerifyCodeDialog = true;
          } else {
            this.$root.$emit("login-success");
          }

          this.loading = false;
        });
      });
    },
  },
};
</script>
<style scoped>
.vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.horizontal-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>